<script setup lang="ts">
import { useSlots } from 'vue';
import { trans } from '../../../../_00_elements/translation';

interface DetailItem {
  label: string;
  value: string | number | null | undefined;
  status?: boolean;
  html?: boolean;
}

withDefaults(defineProps<{
  details?: DetailItem[];
}>(), {
  details: undefined,
});

const slots = useSlots();
const hasSlot = (slot: string): boolean => !!slots[slot];
</script>

<template>
  <div class="subscription-details-section">
    <template v-if="hasSlot('details')">
      <slot name="details" />
    </template>
    <template v-else>
      <div v-for="detail in details" :key="detail.label" class="subscription-details-section__item">
        <span class="subscription-details-section__label">{{ detail.label }}</span>
        <span class="subscription-details-section__value">
          <span
            v-if="detail.status"
            :class="`subscription-details-section__value-label subscription-details-section__value-label--${detail.value}`"
          >
            {{ trans(`gestion.subscription.status.${detail.value}`) }}
          </span>
          <!-- eslint-disable vue/no-v-html -->
          <span v-else-if="detail.html" v-html="detail.value" />
          <!-- eslint-enable vue/no-v-html -->
          <span v-else>{{ detail.value }}</span>
        </span>
      </div>
    </template>
  </div>
</template>
